import { IconWithTextRecord } from "../types";

// Helper function to check for more than three repetitive characters
const hasMoreThanThreeRepetitiveCharacters = (password: string): boolean => {
    for (let i = 0; i < password.length - 3; i++) {
      if (password[i] === password[i + 1] && password[i] === password[i + 2] && password[i] === password[i + 3]) {
        return true;
      }
    }
    return false;
  };
  
// Helper function to check for more than three sequential characters
const hasMoreThanThreeSequentialCharacters = (password: string): boolean => {
    const sequentialStrings = [
        '0123456789',
        'abcdefghijklmnopqrstuvwxyz',
        'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    ];

    for (let i = 0; i < password.length - 3; i++) {
        for (const seq of sequentialStrings) {
        if (seq.includes(password.substring(i, i + 4))) {
            return true;
        }
        }
    }
    return false;
};

export default class PasswordValidation {
    static get_initial_password_validation_list(): IconWithTextRecord[] {
        const validationList: IconWithTextRecord[] = [
            {
                icon: "",
                text: "Does not contain spaces"
            },
            {
                icon: "",
                text: "Contains 8 to 20 characters"
            },
            {
                icon: "",
                text: "Contains at least one number"
            },
            {
                icon: "",
                text: "Contains at least one lower case letter"
            },
            {
                icon: "",
                text: "Contains at least one upper case letter"
            },
            {
                icon: "",
                text: "Contains at least one special character"
            },
            {
                icon: "",
                text: 'Contains no more than three repetitive characters',
            },
            {
                icon: "",
                text: 'Contains no more than three sequential characters',
            }
        ];
    
        return validationList;
    }

    static get_password_validation_list(password: string): IconWithTextRecord[] {
        const validationList: IconWithTextRecord[] = [
            {
                icon: password.match(/\s/)
                ? "<span class=\"glyphicon glyphicon-remove\" style=\"color: #FF0000;\"></span>"
                : "<span class=\"glyphicon glyphicon-ok\" style=\"color: #008000;\"></span>",
                text: "Does not contain spaces"
            },
            {
                icon: password.length >= 8 && password.length <= 20
                ? "<span class=\"glyphicon glyphicon-ok\" style=\"color: #008000;\"></span>"
                : "<span class=\"glyphicon glyphicon-remove\" style=\"color: #FF0000;\"></span>",
                text: "Contains 8 to 20 characters"
            },
            {
                icon: password.match(/\d/)
                ? "<span class=\"glyphicon glyphicon-ok\" style=\"color: #008000;\"></span>"
                : "<span class=\"glyphicon glyphicon-remove\" style=\"color: #FF0000;\"></span>",
                text: "Contains at least one number"
            },
            {
                icon: password.match(/[a-z]/)
                ? "<span class=\"glyphicon glyphicon-ok\" style=\"color: #008000;\"></span>"
                : "<span class=\"glyphicon glyphicon-remove\" style=\"color: #FF0000;\"></span>",
                text: "Contains at least one lower case letter"
            },
            {
                icon: password.match(/[A-Z]/)
                ? "<span class=\"glyphicon glyphicon-ok\" style=\"color: #008000;\"></span>"
                : "<span class=\"glyphicon glyphicon-remove\" style=\"color: #FF0000;\"></span>",
                text: "Contains at least one upper case letter"
            },
            {
                icon: password.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/)
                ? "<span class=\"glyphicon glyphicon-ok\" style=\"color: #008000;\"></span>"
                : "<span class=\"glyphicon glyphicon-remove\" style=\"color: #FF0000;\"></span>",
                text: "Contains at least one special character"
            },
            {
                icon: hasMoreThanThreeRepetitiveCharacters(password)
                ? '<span class=\"glyphicon glyphicon-remove\" style=\"color: #FF0000;\"></span>'
                : '<span class=\"glyphicon glyphicon-ok\" style=\"color: #008000;\"></span>',
                text: 'Contains no more than three repetitive characters',
            },
            {
                icon: hasMoreThanThreeSequentialCharacters(password)
                ? '<span class=\"glyphicon glyphicon-remove\" style=\"color: #FF0000;\"></span>'
                : '<span class=\"glyphicon glyphicon-ok\" style=\"color: #008000;\"></span>',
                text: 'Contains no more than three sequential characters',
            }
        ];
    
        return validationList;
    }

}